/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JofiInterestGroup } from '../models/jofi-interest-group';

@Injectable({
  providedIn: 'root',
})
export class JofiAdminInterestGroupsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation interestGroupsAdminControllerFindAll
   */
  static readonly InterestGroupsAdminControllerFindAllPath = '/v1/admin/interest-groups';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `interestGroupsAdminControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  interestGroupsAdminControllerFindAll$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<JofiInterestGroup>>> {

    const rb = new RequestBuilder(this.rootUrl, JofiAdminInterestGroupsService.InterestGroupsAdminControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JofiInterestGroup>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `interestGroupsAdminControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  interestGroupsAdminControllerFindAll(params?: {
    context?: HttpContext
  }
): Observable<Array<JofiInterestGroup>> {

    return this.interestGroupsAdminControllerFindAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JofiInterestGroup>>) => r.body as Array<JofiInterestGroup>)
    );
  }

}
